import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';
import {
  Auth, SatCoreComponent, accommodationsManager, assignmentManager,
  classroomManager, contentManager, courseManager, dialogManager,
  gradebookManager, i18nAddSatellite, navigationManager,
  studentProgressManager, userManager
} from 'sat-core';
import { API_ROOT, LESSON_ROOT, PUBLISHER_ROOT, PUBLISHER_SATELLITE_CODE } from './api-config';

// import customDefaultAssignmentCardImg from './img/gladeo-card-image-default.svg';
// import iconCommentActiveYellow from './img/icon-comment-active-yellow.svg';
import logo from './img/gladeo-logo-sm.png';

import 'semantic-ui-less/semantic.less';
import './index.less';
import * as serviceWorker from './serviceWorker';

/* Put component override imports here */
import './views/MainViewOverride';
import './views/LoginOverride';
import './views/ProgressViewOverride';
import './components/CourseListBannerOverride';
import './components/StudentAssignmentCardOverride';
import './services/AccommodationsServiceOverride';

import gladeoTranslations from './gladeoTranslations';

i18nAddSatellite('gladeo', gladeoTranslations);

const App = SatCoreComponent('App');
Auth.init(API_ROOT, PUBLISHER_ROOT, PUBLISHER_SATELLITE_CODE, logo, LESSON_ROOT, {});

// assignmentManager.setCustomDefaultAssignmentCardImg(customDefaultAssignmentCardImg);
// dialogManager.setUseWhiteInfoIcon(true);
accommodationsManager.setIncludeAssignmentAccommodations(false);
accommodationsManager.setIncludeClassroomAccommodations(false);
assignmentManager.setEnableCourseSearch(true);
assignmentManager.setLateSubmissionOptionAllowed(true);
classroomManager.setEnabledStudentsOnly(false);
classroomManager.setIncludeGroups(true);
contentManager.setResourceIFrameUrl('http://help.gladeo.org/');
contentManager.setResourceIFrameUrlStudent('http://help.gladeo.org/');
courseManager.setAllowStudentBooks(false);
gradebookManager.setAllowAssignmentLink(true);
navigationManager.setAllowCarouselAdaptiveHeight(true);
studentProgressManager.setAllowStudentProgressNavTab(false);
userManager.setAllowStudentUsernamesAsEmail(true);
userManager.setClientPrefix('GLAD');

ReactDOM.render(
  <Provider
    assignmentManager={assignmentManager}
    classroomManager={classroomManager}
    contentManager={contentManager}
    courseManager={courseManager}
    dialogManager={dialogManager}
    gradeBookManager={gradebookManager}
    navigationManager={navigationManager}
    userManager={userManager}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
